<template>
  <div class="TextOneColumnContentBlock">
    <div class="grid">
      <div class="col-8-12 push-1-12 sm-push-0 sm-col-1-1">
        <UIHeadingType
          v-if="content.title"
          class="mb-xxlg"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
        <div
          class="text raw"
          v-html="content.text"
        />

        <div class="btn-container">
          <UIContentblockButton
            class="btn btn-tertiary mt-xlg"
            :name="content.linkObject?.name"
            :link="content.linkObject?.link"
            :target="content.linkObject?.target"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TextOneColumnContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  defineProps<{
    content: TextOneColumnContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()
</script>
